// extracted by mini-css-extract-plugin
export default {"reviewBottomSheetList":"reviewBottomSheetList_St28Q"};